<template>
    <ButtonGroup>
        <Button v-bind="greaterProps" @click="model = MODIFIER_TYPE.GREATER_THAN">
            <Icon name="caret-up" class="text-xl" />
        </Button>
        <Button v-bind="lesserProps" @click="model = MODIFIER_TYPE.LESS_THAN">
            <Icon name="caret-down" class="text-xl" />
        </Button>
    </ButtonGroup>
</template>
<script setup lang="ts">
import type { ButtonVariants } from "~/components/ui";

const model = defineModel<number>();

const greaterProps = makeButtonPropsComputed(MODIFIER_TYPE.GREATER_THAN);

const lesserProps = makeButtonPropsComputed(MODIFIER_TYPE.LESS_THAN);

function makeButtonPropsComputed(modifierType: number) {
    return computed<ButtonVariants>(() =>
        model.value === modifierType ? { size: "icon", variant: "accent", fill: "solid" } : { size: "icon" }
    );
}
</script>
